// extracted by mini-css-extract-plugin
export default {"rating":"LB-z","numberOfStars":"MB-z","count":"NB-z","barGraphSpacing":"OB-z","barGraph":"PB-z"};